// constants
import { ReportBuilderActionTypes } from './constants';

export interface ReportBuilderActionType<TPayload> {
    type:
  
    | ReportBuilderActionTypes.CHANGE_REPORT_LOCATION   
    | ReportBuilderActionTypes.CHANGE_CHARTS 
    |ReportBuilderActionTypes.GET_CHARTLIST_REPORT  
    |ReportBuilderActionTypes.UPDATE_ELEMENT 
    |ReportBuilderActionTypes.ADD_ELEMENT 
    |ReportBuilderActionTypes.UPDATE_SECTION_HEIGHT
    |ReportBuilderActionTypes.DELETE_ELEMENT
    |ReportBuilderActionTypes.SET_SECTIONS
    |ReportBuilderActionTypes.SET_SELECTED
    |ReportBuilderActionTypes.ADD_FILTER
    |ReportBuilderActionTypes.UPDATE_FILTER
    |ReportBuilderActionTypes.SET_FILTERS
    |ReportBuilderActionTypes.SET_PREVIEW_FILTER_VALUE
    |ReportBuilderActionTypes.RESET_PREVIEW_FILTERS

    |ReportBuilderActionTypes.DELETE_FILTER




    payload?: TPayload;
}

export const changeReportLocationAction = (layout: any): ReportBuilderActionType<any> => ({
    type: ReportBuilderActionTypes.CHANGE_REPORT_LOCATION,
    payload: layout,
});

export const getReportChartsAction = (layout: any): ReportBuilderActionType<any> => ({
    type: ReportBuilderActionTypes.GET_CHARTLIST_REPORT,
    payload: layout,
});

export const changeReportChartsAction = (layout: any): ReportBuilderActionType<any> => ({
    type: ReportBuilderActionTypes.CHANGE_CHARTS,
    payload: layout,
});
export const changeReportElementAction = (layout: any): ReportBuilderActionType<any> => ({
    type: ReportBuilderActionTypes.UPDATE_ELEMENT,
    payload: layout,
});
export const changeReportAddElementAction = (layout: any): ReportBuilderActionType<any> => ({
    type: ReportBuilderActionTypes.ADD_ELEMENT,
    payload: layout,
});
export const changeReportUpdateSectionElementAction = (layout: any): ReportBuilderActionType<any> => ({
    type: ReportBuilderActionTypes.UPDATE_SECTION_HEIGHT,
    payload: layout,
});
export const changeReportDeleteElementAction = (layout: any): ReportBuilderActionType<any> => ({
    type: ReportBuilderActionTypes.DELETE_ELEMENT,
    payload: layout,
});
export const changeReportSetSectionAction = (layout: any): ReportBuilderActionType<any> => ({
    type: ReportBuilderActionTypes.SET_SECTIONS,
    payload: layout,
});
export const changeReportSelectedAction = (layout: any): ReportBuilderActionType<any> => ({
    type: ReportBuilderActionTypes.SET_SELECTED,
    payload: layout,
});

export const changeReportAddFilterAction = (filter: any): ReportBuilderActionType<any> => ({
    type: ReportBuilderActionTypes.ADD_FILTER,
    payload: filter,
});

export const changeReportUpdateFilterAction = (filter: any): ReportBuilderActionType<any> => ({
    type: ReportBuilderActionTypes.UPDATE_FILTER,
    payload: filter,
});

export const changeReportDeleteFilterAction = (filterId: any): ReportBuilderActionType<any> => ({
    type: ReportBuilderActionTypes.DELETE_FILTER,
    payload: filterId,
});

export const changeReportSetFiltersAction = (filters: any): ReportBuilderActionType<any> => ({
    type: ReportBuilderActionTypes.SET_FILTERS,
    payload: filters,
});
export const changeReportPreviewFilterValueAction = (filter: any): ReportBuilderActionType<any> => ({
    type: ReportBuilderActionTypes.SET_PREVIEW_FILTER_VALUE,
    payload: filter,
});

export const resetReportPreviewFiltersAction = (): ReportBuilderActionType<any> => ({
    type: ReportBuilderActionTypes.RESET_PREVIEW_FILTERS,
});

